import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { theme } from 'styles/theme/hav-theme'

type TagContainerProps = {
  disabled: boolean
}

export const TagContainer = styled.div<TagContainerProps>`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  background: ${theme.colors.quartenary};
  border-radius: ${theme.shapes.borderRadius.sm};
  padding: 8px;
  height: 18px;

  &:hover {
    background: ${theme.colors.primary.hover};

    span {
      color: ${theme.colors.neutral.white};
    }

    svg {
      path {
        fill: ${theme.colors.neutral.white};
      }
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      background: ${theme.colors.neutral.white};
      border: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.clear};

      span {
        color: ${theme.colors.neutral.mediumhover};
      }

      svg {
        path {
          fill: ${theme.colors.neutral.clear};
        }
      }
    `}
`

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  border: none;
  outline: none;
  width: fit-content;
  background: transparent;
`

export const TagText = styled.span`
  margin-top: 1px;
  user-select: none;
  white-space: nowrap;
  font-size: ${theme.typography.sizes['2xs']};
  line-height: ${theme.typography.lineHeight.sm};
  font-weight: ${theme.typography.weight.sm};
  color: ${theme.colors.neutral['700']};
`
